import { IconWrapper } from '../runtime';
export default IconWrapper('pushpin', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.6039 11.3183L4.60451 14.7827M7.0489 2.0489L6.8239 2.43861C6.74106 2.58209 6.7923 2.76212 6.9294 2.85515C7.36006 3.14737 7.84199 3.67522 7.22294 4.74745C6.47294 6.04649 6.03992 5.79649 5.35691 5.9795C4.7085 6.15324 2.82896 6.65687 1.7846 8.18937C1.6913 8.32629 1.73835 8.50913 1.88184 8.59197L11.326 14.0445C11.4695 14.1274 11.6525 14.0774 11.7245 13.9282C12.5295 12.2575 12.0258 10.3779 11.8521 9.7295C11.6691 9.04649 11.2361 8.79649 11.9861 7.49745C12.6051 6.42522 13.3032 6.57866 13.7716 6.80551C13.9207 6.87773 14.1021 6.83242 14.1849 6.68893L14.4101 6.29894C14.8243 5.5815 14.5785 4.66407 13.8611 4.24986L9.09794 1.49986C8.3805 1.08564 7.46311 1.33146 7.0489 2.0489Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});